<template>
    <div>
        <div class="card card-body">
            <h3 class="mb-7">
                {{ storeCreationRequestSucceeded ? __('store.store_created') : __('navigation.create_store') }}
            </h3>
            <div v-if="storeCreationRequestSucceeded" class="card alert alert-elevate" role="alert"
                 v-html="__('store-creation-request.success_message', {'storeName': storeName})"
            />
            <div v-else>
                <create-store
                    :local-business-types="localBusinessTypes"
                    :language="language"
                    :users-phone="usersPhone"
                    :countries="countries"
                    :form-submit="formSubmit"
                />
            </div>
            <a v-if="storeCreationRequestSucceeded" :href="$route('user.requests.index')">
                <i class="fa fa-fw fa-long-arrow-alt-left"></i> {{ __('actions.show_my_requests') }}
            </a>
        </div>
    </div>
</template>

<script>
import CreateStore from '@components/CreateStore.vue'
import StoreLayout from '@layouts/StoreLayout.vue'

export default {
    layout: StoreLayout,

    components: {CreateStore},

    props: {
        localBusinessTypes: Array,
        language: Object,
        usersPhone: String,
        formSubmit: {
            type: Boolean,
            default: true,
        },
        countries: Object,
        frontendUrl: String,

        storeCreationRequestSucceeded: {
            type: Boolean,
        },
        storeName: {
            type: String,
        },
    },

    data() {
        return {
            creationRequestSucceeded: this.storeCreationRequestSucceeded,
            store: this.storeName,
        }
    },
}
</script>
